module.exports = __webpack_public_path__ + "static/media/38import-73.5011438a.xlsx";